import React, { useEffect, useMemo, CSSProperties, useState } from 'react'
import { getBEMCls } from '@/utils/classname'
import Iconfont from '@/components/iconfont/iconfont'

import './sidebar-item.scss'
import { Column, Row } from '@/components/layout/layout'
import { observer } from 'mobx-react'
import { useLocation } from 'react-router'

export interface ISecondGroup {
    id: number
    title: string
    secondPath?: string
    activeSecondPaths?: string[]
    onClick?: () => void
}

interface SidebarItem {
    id: number
    title: string
    icon: string
    iconImg?: string
    iconActive?: string
    imgActive?: string
    path?: string
    count?: number
    secondGroup?: ISecondGroup[]
    onClick?: () => void
    style?: CSSProperties
}

const SidebarItem: React.FC<SidebarItem> = observer(props => {
    const getCls = (el?: string, moder?: string) => getBEMCls('sidebar-item', el, moder)
    const [open, setOpen] = useState<boolean>(false)

    const location = useLocation()

    const paths = useMemo(() => {
        const pathArr = location.pathname.split('/')

        return {
            path: pathArr[2],
            secondPath: pathArr[3],
        }
    }, [location])

    const isActive = useMemo(() => props.path === paths.path, [props.path, paths]) // 一级分组是否激活

    useEffect(() => {
        setOpen(isActive)
    }, [isActive])

    return (
        <Column style={props?.style}>
            <div
                className={isActive && !props.secondGroup?.length ? getCls('active') : getCls('container')}
                onClick={() => {
                    props.onClick && props.onClick()
                    setOpen(!open)
                }}
            >
                {/* 装饰线 */}
                <div
                    className={getCls('line')}
                    style={{
                        backgroundColor: isActive && !props.secondGroup?.length ? '#12d49d' : 'transparent',
                        height: isActive && !props.secondGroup?.length ? '60px' : '40px',
                    }}
                />

                <Row data-align-items-center>
                    {props.iconImg ? (
                        <img src={props.iconImg} alt="" className={getCls('ai-avatar')} referrerPolicy="no-referrer" />
                    ) : !isActive ? (
                        <i className={`${getCls('icon')} iconfont ${props.icon}`} />
                    ) : props.iconActive ? (
                        <Iconfont size={24} name={props.iconActive} className={`${getCls('icon', 'active')}`} />
                    ) : (
                        <img src={props.imgActive} alt="" className={`${getCls('icon', 'active')}`} />
                    )}

                    <span className={isActive ? getCls('title', 'active') : getCls('title')}>{props.title}</span>
                    {props.count && <span className={getCls('badge')}>{props.count}</span>}
                </Row>

                {!!props.secondGroup?.length && (
                    <i
                        className={`iconfont icon6xiala2-202 ${getCls('arrow')}`}
                        style={{
                            transform: `rotate(${open ? '180' : '0'}deg)`,
                        }}
                    />
                )}
            </div>

            {!!props.secondGroup?.length && (
                <ul
                    className={getCls('second')}
                    style={{
                        height: open ? `${props.secondGroup?.length * 50}px` : '0',
                    }}
                    onTransitionEnd={event => {
                        if (open && event.target === event.currentTarget && event.propertyName === 'height') {
                            event.currentTarget.scrollIntoView({ block: 'nearest', behavior: 'smooth' })
                        }
                    }}
                >
                    {props.secondGroup.map(second => (
                        <li
                            className={
                                paths.secondPath === second.secondPath ||
                                second.activeSecondPaths?.includes(paths.secondPath)
                                    ? getCls('second', 'item-active')
                                    : getCls('second', 'item')
                            }
                            key={second.id}
                            onClick={() => {
                                second.onClick && second.onClick()
                            }}
                        >
                            {second.title}
                        </li>
                    ))}
                </ul>
            )}
        </Column>
    )
})

export default SidebarItem
